import { ModalPage } from 'components/ModalPage/ModalPage'
import { EditPage } from 'components/PopupEditPage/EditPage/EditPage'


type Props = {
    onClose: () => void,
}

export function PopupEditPage(props: Props) {
    return (
        <ModalPage hideCross>
            <EditPage onClose={props.onClose} />
        </ModalPage>
    )
}

